module.exports = __webpack_public_path__ + "img/doQuestion.615221f5.png";